export const isClientDevEnv = import.meta.env.MODE === 'development'